import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

export const useFireDateFilterSelectedAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return (dateFilterType: string) =>
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'selected',
				actionSubject: 'dateFilter',
			}),
			'dateFilterSelected',
			{
				dateFilterType,
			},
		);
};

export const useFireFormCancelledAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return () =>
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'cancelled',
				actionSubject: 'form',
			}),
			'dateRangePickerCancel',
		);
};
